import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.typeOfInput), {
    control: _ctx.control,
    dense: _ctx.dense,
    showInvalidRequiredInput: _ctx.showInvalidRequiredInput,
    onChangeControl: _ctx.emitChangeControl,
    class: "required-input"
  }, null, 40, ["control", "dense", "showInvalidRequiredInput", "onChangeControl"]))
}